import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { getOptionsQueryParams } from "@app/class/Utilities";
import { Observable, Subject } from "rxjs";
import { map } from "rxjs/operators";
import { SignalRService, WebSocketEvents } from "../../../developerConsole/signalr.service";
import { ICameraCommand } from "../../_models/ICameraCommand";
import { ILatestPulseRecordQueryOptions, IPulseRecord, IPulseRecordQueryOptions } from "../../_models/IPulseRecord";

@Injectable({
    providedIn: 'root'
})
export class PulseService {
    constructor(
        private readonly http: HttpClient,
        private readonly signalRService: SignalRService) { }


    pulseMessageReceived = new Subject<IPulseRecord>();

    getPulseMessages(serial: string): Observable<IPulseRecord> {
        this.signalRService.initialise().then(() => {
            this.signalRService.joinDeviceGroup(serial);
            this.signalRService.registerEvents<IPulseRecord>(WebSocketEvents.Pulse, this.pulseMessageReceived);
        })
        return this.pulseMessageReceived;
    }

    getHistoricalPulseMessages(options: IPulseRecordQueryOptions = {}): Observable<IPulseRecord[]> {
        const getParams = getOptionsQueryParams(options);
        return this.http.get<IPulseRecord[]>('/api/cameras/commserver/pulserecords', getParams);
    }

    getLatestPulseMessage(options: ILatestPulseRecordQueryOptions = {}): Observable<IPulseRecord> {
        return this.http.get<IPulseRecord>('/api/cameras/commserver/pulserecords/latest', { params: options as HttpParams });
    }

    getPulseResponse(pulseId: number): Observable<ICameraCommand> {
        return this.http.get<ICameraCommand[]>(`/api/cameras/commserver/pulserecords/${pulseId}/response`).pipe(
            map(response => {
                if (!response.length) {
                    return;
                }

                const responseJson = response[0].CommandJson;
                response[0].parsedCommand = responseJson ? JSON.parse(responseJson) : null;
                return response[0];
            })
        );
    }

    extractGuid(rawValue: string): string | null {
        const match = rawValue.match(/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/);
        return match ? match[0] : null;
    }
}
